module.exports = __webpack_public_path__ + "static/media/contouring_plants_website.efd00cf2.png";